import React from 'react';
import { getItemSlotStyle } from '../systems/itemPositionStyle.js';

/**
 * @param {{ id: string, item: object, points: number, tone: string }} floater
 * @param {{ width: number, height: number }} boardSize
 */
export function ScoreFloater({ floater, boardSize }) {
    const { item, points, tone } = floater;
    const label = points > 0 ? `+${points}` : String(points);

    return (
        <div
            className="lp-game__score-floater-slot"
            style={{
                ...getItemSlotStyle(item, boardSize),
                zIndex: (item.zIndex ?? 4) + 4,
            }}
            aria-hidden
        >
            <span className={`lp-game__score-floater lp-game__score-floater--${tone}`}>
                {label}
            </span>
        </div>
    );
}
